import gql from 'graphql-tag'

export const UpdateWorkerMutation = gql`
  mutation UpdateWorkerMutation ($input: UpdateWorkerInput!) {
    updateWorker(input: $input) {
      id
    }
  }
`
